import React from "react";
import Container from "../Container";
import Section from "../Section";
import { ContentAndVideo } from "../ContentAndVideo";

export const ContentAndVideoFlexi = ({
  content,
  video,
  placement,
  background,
}) => {
  return (
    <Section grey={background === "grey"}>
      <Container>
        <ContentAndVideo
          content={content}
          video={video}
          placement={placement}
        />
      </Container>
    </Section>
  );
};
